<i18n lang='yml' src='../i18n/Week.yml'></i18n>

<template>
  <div class="calendar-row">
    <table v-if="events">
      <thead class='calendar-row-header'>
        <tr>
          <th :aria-disabled="isBefore(weekday, todaysDate)" :class="isBefore(weekday, todaysDate) ? 'past-date' : ''" v-for="weekday in weekdays" :key="weekday.getDate()" width="20">
            <span>{{$t(`${dateType}_${weekday.getDay()}`)}} {{weekday.getDate()}}</span>
          </th>
        </tr>
      </thead>   
      <!-- Desktop View -->
      <tbody v-if="uniqueStartTimes.length > 0" class="hidden-sm">
   
        <tr v-for="startTime in uniqueStartTimes" :key="startTime" >
          <td v-for="weekday in weekdays" :key="weekday.getDate()" width="20">
            <div v-for="event in eventsForWeekday(startTimes[startTime], weekday.getDate())" :class="`cal-sitting ${getEventStatus(event)}`"  :key="event.id">
              <div v-if="sessions.findIndex(val => val.id === event.id) !== -1" class="selected-check"><font-awesome-icon :icon="['fas', 'check']" /></div>
              <label v-if="event == 'no-sitting'" class="sr-only">{{$t('no_sittings')}}</label>
              <div v-else>
                <button class="sitting-info btn w-100" tabindex="0" @click="selectEvent(event)" @keydown="selectEvent(event)">
                  <span>
                    {{ formatTime(event.start_time) }} - {{ formatTime(event.end_time) }}
                  </span>
                  <hr/>
                  <span>
                    {{ bookingRequiresPrivateRoom ? event.booth_capacity - event.booked_booth : event.remaining_capacity}} 
                    {{ bookingRequiresPrivateRoom ? $t('private_room_seats_remaining') : $t('seats_remaining') }}
                  </span>
                </button>
                <div :class="selectedID == event.id? 'popover-menu show' : 'popover-menu'" :id="`popover-menu-${event.id}`" @mouseleave="closePopover">
                  <div class="popover-body">
                    <a tabindex="0" href="#" @click.prevent="showSessionInfo(event)">{{$t('view_session')}}</a>
                    <a v-if="edit_permission == 'true'" tabindex="0" :href="`${sitting_path}/${event.id}/edit`">{{$t('edit_session')}}</a>
                    <a v-if="event.series_id && edit_permission == 'true'" :href="`${sub_location_path}/series/${event.series_id}/edit`" tabindex="0" >
                      {{$t('edit_series')}}
                    </a>
                    <a tabindex="0" v-if="event.all_bookings > 0" :href="`${sitting_path}/${event.id}/exam_report`" target="_blank"> {{$t('view_exam_report')}}</a>
                    <button class="btn btn-sm btn-close" @click="closePopover" @keydown="closePopover">                                         
                      <font-awesome-icon :icon="['fa', 'times']" />
                      <span class="sr-only">{{$t('close')}}</span>
                    </button>
                  </div>
                </div>    
              </div>
            </div>
          </td>
        </tr>

      </tbody>
      <!-- Mobile View -->
      <tbody v-if="uniqueStartTimes.length > 0" class="d-md-none">
        <tr v-for="weekday in weekdays" :key="weekday.getDate()" width="20" :class="eventsForWeekday(events, weekday.getDate()).length == 0 ? 'cal-no-sittings-mobile' : ''">
          <td >
            <div class="cal-th-mobile">{{$t(`${dateType}_${weekday.getDay()}`)}} {{weekday.getDate()}}</div>

            <div v-if="eventsForWeekday(events, weekday.getDate()).length == 0" class="no-sitting">{{$t('no_sittings')}}</div>
            
          </td>
        
          <td v-for="startTime in uniqueStartTimes" :key="startTime">
            <div v-for="event in eventsForWeekday(startTimes[startTime], weekday.getDate())" :class="`cal-sitting ${getEventStatus(event)}`"  :key="event.id">
              <div v-if="sessions.findIndex(val => val.id === event.id) !== -1" class="selected-check"><font-awesome-icon :icon="['fas', 'check']" /></div>
      
              <div>
                <button class="sitting-info btn w-100" tabindex="0" @click="selectEvent(event)" @keydown="selectEvent(event)">
                  <span>
                    {{ formatTime(event.start_time) }} - {{ formatTime(event.end_time) }}
                  </span>
                  <hr/>
                  <span>
                    {{ bookingRequiresPrivateRoom ? event.booth_capacity - event.booked_booth : event.remaining_capacity}} 
                    {{ bookingRequiresPrivateRoom ? $t('private_room_seats_remaining') : $t('seats_remaining') }}
                  </span>
                </button>
                <div :class="selectedID == event.id? 'popover-menu show' : 'popover-menu'" :id="`popover-menu-${event.id}`" @mouseleave="closePopover">
                  <div class="popover-body">
                    <a tabindex="0" href="#" @click.prevent="showSessionInfo(event)">{{$t('view_session')}}</a>
                    <a v-if="edit_permission == 'true'" tabindex="0" :href="`${sitting_path}/${event.id}/edit`">{{$t('edit_session')}}</a>
                    <a v-if="event.series_id && edit_permission == 'true'" :href="`${sub_location_path}/series/${event.series_id}/edit`" tabindex="0" >
                      {{$t('edit_series')}}
                    </a>
                    <a tabindex="0" v-if="event.all_bookings > 0" :href="`${sitting_path}/${event.id}/exam_report`" target="_blank"> {{$t('view_exam_report')}}</a>
                    <button class="btn btn-sm btn-close" @click="closePopover" @keydown="closePopover">                                         
                      <font-awesome-icon :icon="['fa', 'times']" />
                      <span class="sr-only">{{$t('close')}}</span>
                    </button>
                  </div>
                </div>

                  <div v-if="details && Object.keys(details).length > 0" :class="details.id == event.id? 'show-mobile-session' : 'hide-mobile-session'">
                    <session-details
                      @nextStep="nextStep"
                      @addToCart="addToCart"
                      :time_format_en="time_format_en" :time_format_fr="time_format_fr"
                      :booking_details="booking_details"
                      :selectedSession="selectedSession"
                      :sessions="sessions"
                      :locale="locale"
                      :admin="edit_permission"
                      :type="type"
                      :details="details"
                      :context="context" v-on="$listeners"  />

                  </div>
              </div>
            </div>
            
          </td>
        </tr> 
      </tbody>
      <tbody v-else >
        <!-- Desktop View no sessions-->

        <tr class="hidden-sm">
          <td v-for="weekday in weekdays" :key="weekday.getDate()"  width="20" height="47"></td>
        </tr>

        <!-- Mobile View no sessions-->
  
        <tr v-for="weekday in weekdays" :key="weekday.getDate()"  width="20" height="47" class="d-md-none cal-no-sittings-mobile">
          <td >
            <div class="cal-th-mobile">{{$t(`${dateType}_${weekday.getDay()}`)}} {{weekday.getDate()}}</div>
            <div class="no-sitting">{{$t('no_sittings')}}</div>     
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</template>

<script>

import SessionDetails from './SessionDetails.vue'
import { sendAjaxRequest } from '../../typescripts/ajax.ts'

import {formatTime} from '../../../shared/typescripts/dates.ts'
export default {
    components: {
      'session-details' :SessionDetails,
    },
    props: [ 'weekdays', 'locale', 'context', 'sitting_path', 'sub_location', 'session_open', 'sub_location_path', 'booking_details','nextStep', 'details', 'clearSession', 'edit_permission', 'sessions', 'selectedSession', 'type', 'time_format_en', 'time_format_fr'],
    data() {
      return {
          todaysDate: new Date().setHours(0,0,0,0),
          days: null,   
          selectedID: null,
          events: [],
            dateType: "short",
          mobileView: false
        }
    },
    mounted() {
      this.checkScreenWidth();
      this.onScreenResize();
      this.getSittings();
    },
    computed: {
      startTimes() {
        const startTimes = {}
        this.events.forEach((event) => {
          if(startTimes[event.formatted_start_time] == null) {
            startTimes[event.formatted_start_time] = [event]
          }
          else {
            startTimes[event.formatted_start_time].push(event)
          }
        })
        return startTimes
      },
      uniqueStartTimes() {
        return Object.keys(this.startTimes).sort()
      },
      bookingHasAccommodations() {
        return this.booking_details && this.booking_details.accommodations 
      },
      bookingRequiresPrivateRoom() {
        return this.bookingHasAccommodations && this.booking_details.accommodations.accommodation_types.includes('private_room')
      }
    },
    watch: {  
      weekdays(newVal){
        if(newVal) {
          this.getSittings()
        }
      }
    },
    methods: {   
      getSittings() {
        let params = {
          context: this.context,
          start_date: this.weekdays[0].toLocaleDateString('en-CA'),
          end_date: this.weekdays[this.weekdays.length-1].toLocaleDateString('en-CA') + 'T23:59:59',
          training_program_id: this.booking_details ? this.booking_details.training_program_id : null,
          booking_for_identity_id: this.booking_details ? this.booking_details.user_identity_id : null,
          accommodations: this.bookingHasAccommodations ? this.booking_details.accommodations.accommodation_types : null
        }
        sendAjaxRequest('GET', `${this.sitting_path}.json`, 'json', params, this.ajaxSuccess, this.throwError)
      },

      throwError(message) {
        this.loading = false;
        alert(this.$t('error_loading'));
      },
      ajaxSuccess(data) {
        this.loading = false;
        this.events = data
      },

      eventsForWeekday(events, weekday) {
        return events.filter((e) => parseInt(e.date.split('-')[2]) == weekday)
      },
      getEventStatus(event) {
        let eventStartTime = new Date(new Date(event.start_time).toLocaleString('en-US', { timeZone: 'America/Toronto' }))
        let eventDate = new Date(new Date(event.date).toLocaleString('en-US', { timeZone: 'America/Toronto' }))
        eventDate.setHours(eventStartTime.getHours())
        eventDate.setMinutes(eventStartTime.getMinutes())
        if(event.id == this.selectedID || (this.session_open != null && event.id == this.session_open.id)) {
          return 'cal-selected'
        }
        if (eventDate < new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }))) {
          return 'cal-past'
        }
        if(event.status == 'cancelled' || event.status == 'pending' || (this.bookingRequiresPrivateRoom && event.booked_booth >= event.booth_capacity) || (!this.bookingRequiresPrivateRoom && event.remaining_capacity == 0)) {
          return 'cal-unavailable'
        }
        return 'cal-available'
      },
      formatTime: function (date) {
        let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
        return formatTime(date, format)
      },
      nextStep() {
        this.$emit('nextStep')
      },
      addToCart() {
        this.$emit('addToCart')
      },
      selectEvent(data) {
        this.selectedID = data.id
        if(this.context != 'sub_location') {
          this.showSessionInfo(data)
        }
      },
      showSessionInfo(data) {
        this.$emit('selected', data)
        this.selectedID = ""
      },
      closePopover() {
        this.selectedID = null
      },
      isBefore(date1, date2) {
        return date1 < date2;
      },
      onScreenResize() {
        window.addEventListener("resize", () => {
          this.checkScreenWidth();
        });
      },
      checkScreenWidth() {
        this.mobileView = window.innerWidth < 768
        window.innerWidth > 1200 ? this.dateType = 'long' : this.dateType = 'short'
      },
    },
}
</script>

